import { isCreatedByMe, resourceCreatorName } from '../../../components/only-mine-filter'
import React, { useContext, useState } from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { AuthContext } from "../../../../../auth-context";
import { DashboardContext } from "../../../dashboard-context";
import { Row, Action } from "../../../../../components/action-button";
import DeleteIcon from "@material-ui/icons/DeleteForever";
import { deleteSurveySchedule, loadProfile } from "../../../../../api";
import { ReactComponent as ArrowUp } from "../../../../../images/arrow-up.svg";
import { ReactComponent as ArrowDown } from "../../../../../images/arrow-down.svg";
import moment from "moment";
import EditIcon from "@material-ui/icons/Edit";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableHeadRow,
  TableBodyRow,
  HeadCell,
  DataCell,
} from "../../../../../components/table";

const ArrowsGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const AssignedClients = ({
  onlyMine = false,
  forms,
  handleEdit,
}) => {
  const { user, updateUser } = useContext(AuthContext);
  const { openSnackbar } = useContext(DashboardContext);
  const [sortType, setSortType] = useState({ type: "name", reverse: false });

  const renderSortArrows = (isSorting, reverse) => {
    return (
      <div style={{ display: "inline-block", marginLeft: "8px" }}>
        <ArrowsGroup>
          <ArrowUp fill={isSorting && reverse ? "#FFFFFF" : "#999999"} />
          <div style={{ height: "3px" }}></div>
          <ArrowDown fill={isSorting && !reverse ? "#FFFFFF" : "#999999"} />
        </ArrowsGroup>
      </div>
    );
  };

  const handleSort = (type) => {
    if (type !== sortType.type) {
      setSortType({ type: type, reverse: false });
    } else {
      setSortType({ type: type, reverse: !sortType.reverse });
    }
  };

  const getFormName = (formID) => {
    const form = forms.find((form) => form.id === formID);
    return form?.name;
  };

  const handleDelete = (scheduleID) => {
    deleteSurveySchedule(user.id, scheduleID)
      .then((res) => {
        openSnackbar("Schedule deleted", false);
        const newUser = { ...user }
        newUser.survey_schedules = newUser.survey_schedules.filter((schedule) => schedule.id !== scheduleID)
        updateUser(newUser)
      })
      .catch((err) => {
        openSnackbar("Error deleting schedule", true);
      });
  }

  const scheduledAssignments = user.survey_schedules.filter((schedule) => !onlyMine || isCreatedByMe(schedule, user)).sort((a, b) => new Date(a.schedule_date) - new Date(b.schedule_date))

  return (
    <>
    <TableContainer>
      <Table>
        <TableHead>
          <TableHeadRow>
            <HeadCell onClick={() => handleSort("name")}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                Scheduled Date
                {renderSortArrows(sortType.type === "name", sortType.reverse)}
              </div>
            </HeadCell>
            <HeadCell>Type</HeadCell>
            <HeadCell>Check-in Form</HeadCell>
            <HeadCell># of Clients</HeadCell>
            <HeadCell>Status</HeadCell>
            <HeadCell>Created by</HeadCell>
            <HeadCell style={{ textAlign: "center" }}>Actions</HeadCell>
          </TableHeadRow>
        </TableHead>
        <TableBody>
          {scheduledAssignments.length === 0 && <TableBodyRow><DataCell colSpan={7}>No scheduled assignments match this filter.</DataCell></TableBodyRow>}
          {scheduledAssignments.map((schedule) => {
            const formName = getFormName(schedule.survey_id);
            const localDate = moment.utc(schedule.schedule_date).local().format("MMM D, YYYY h:mm A")
            return (
              <TableBodyRow key={schedule.id}>
                <DataCell onClick={() => handleSort("email_address")}>
                  {localDate}
                </DataCell>
                <DataCell onClick={() => handleSort("type")}>
                  {schedule.schedule_type === 0 ? "Add Assignment" : "Delete Assignment"}
                </DataCell>
                <DataCell onClick={() => handleSort("name")}>
                  {formName || "---"}
                </DataCell>
                <DataCell>{schedule.account_ids.length}</DataCell>
                <DataCell>{schedule.schedule_status === 0 ? "Pending" : "Completed"}</DataCell>
                <DataCell>{resourceCreatorName(schedule, user)}</DataCell>
                <DataCell style={{ display: "flex", justifyContent: "center" }}>
                  <Row>
                    <Action
                      icon={<EditIcon />}
                      text="Edit"
                      disabled={schedule.schedule_status === 1}
                      onClick={() => schedule.schedule_status === 0 && handleEdit(schedule.id)}
                    />
                    <Action
                      icon={<DeleteIcon />}
                      iconColor="#da0f0f"
                      text="Delete"
                      onClick={() => {
                        handleDelete(schedule.id)
                      }}
                    />
                  </Row>
                </DataCell>
              </TableBodyRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
    </>
  );
};

export default withRouter(AssignedClients);
